<template>
  <f7-app :params="f7params">
    <!-- Left panel with cover effect-->
    <f7-panel left cover theme-dark>
      <f7-view v-if="signed_in">
        <f7-page>
          <f7-block>
            <f7-block>Display Name:&nbsp; {{ user[0].name }}</f7-block>
          </f7-block>
          <div class="wrapper">
            <img class="image--cover" :src="user[0].photo_url1" alt />
          </div>

          <f7-block>
            Location:&nbsp; {{ user[0].location }}
            <f7-link @click="editLocation()">
              <f7-icon material="edit" color="blue"></f7-icon>
            </f7-link>
          </f7-block>
          <f7-block>
            Profile Message:&nbsp; {{ user[0].profileMessage }}
            <f7-link @click="editProfileMessage()">
              <f7-icon material="edit" color="blue"></f7-icon>
            </f7-link>
          </f7-block>

          <f7-block>
            Gender Search:&nbsp; {{ user[0].genderSearch }}
            <f7-link @click="genderSearch()">
              <f7-icon material="edit" color="blue"></f7-icon>
            </f7-link>
          </f7-block>

          <f7-block>
            Delete Account
            <f7-link @click="deleteAccount()">
              <f7-icon material="delete" color="blue"></f7-icon>
            </f7-link>
          </f7-block>

          <f7-list>
            <f7-list-item
              @click="signOut"
              view=".view-main"
              panel-close
              title="Sign out"
            ></f7-list-item>
          </f7-list>
        </f7-page>
      </f7-view>
    </f7-panel>

    <!-- Views/Tabs container -->
    <f7-views tabs class="safe-areas" v-if="signed_in">
      <!-- Tabbar for switching views-tabs -->
      <f7-toolbar tabbar labels bottom v-show="show_tabbar">
        <f7-link
          tab-link="#view-home"
          tab-link-active
          icon-ios="f7:home_fil"
          icon-aurora="f7:home_fil"
          icon-md="material:favorite"
          text="Friends"
        ></f7-link>
        <f7-link
          tab-link="#view-members"
          icon-ios="f7:people_round_fill"
          icon-aurora="f7:people_round_fill"
          icon-md="material:person"
          text="Members"
        ></f7-link>
        <f7-link
          tab-link="#view-match"
          icon-ios="f7:persons_round_fill"
          icon-aurora="f7:persons_round_fill"
          icon-md="material:people"
          text="Match"
        ></f7-link>
      </f7-toolbar>

      <!-- Your main view/tab, should have "view-main" class. It also has "tab-active" class -->
      <f7-view id="view-home" main tab tab-active url="/"></f7-view>

      <!-- Members View -->
      <f7-view id="view-members" name="members" tab url="/members/"> </f7-view>

      <!-- Search View -->
      <f7-view id="view-match" name="match" tab url="/match/"></f7-view>
    </f7-views>

    <f7-view v-if="!signed_in" url="/firstpage/" :main="true"></f7-view>

    <!-- Popup -->
    <f7-popup id="my-popup">
      <f7-view>
        <f7-page>
          <f7-navbar title="Popup">
            <f7-nav-right>
              <f7-link popup-close>Close</f7-link>
            </f7-nav-right>
          </f7-navbar>
          <f7-block>
            <p>Popup content goes here.</p>
          </f7-block>
        </f7-page>
      </f7-view>
    </f7-popup>

    <f7-login-screen id="my-login-screen">
      <f7-view>
        <f7-page login-screen>
          <f7-login-screen-title>Login</f7-login-screen-title>
          <f7-list form>
            <f7-list-input
              type="text"
              name="username"
              placeholder="Your username"
              :value="username"
              @input="username = $event.target.value"
            ></f7-list-input>
            <f7-list-input
              type="password"
              name="password"
              placeholder="Your password"
              :value="password"
              @input="password = $event.target.value"
            ></f7-list-input>
          </f7-list>
          <f7-list>
            <f7-list-button
              title="Sign In"
              login-screen-close
              @click="alertLoginData"
            ></f7-list-button>
            <f7-block-footer>
              Some text about login information.
              <br />Click "Sign In" to close Login Screen
            </f7-block-footer>
          </f7-list>
        </f7-page>
      </f7-view>
    </f7-login-screen>
  </f7-app>
</template>

<script>
import firebase from "firebase";
import cordovaApp from "../js/cordova-app.js";
import routes from "../js/routes.js";

var firebaseConfig = {
  apiKey: "AIzaSyBPJabpZ-EAlk65E3SlYZfqnw48QFkL7ps",
  authDomain: "misscomely.firebaseapp.com",
  databaseURL: "https://misscomely-default-rtdb.firebaseio.com",
  projectId: "misscomely",
  storageBucket: "misscomely.appspot.com",
  messagingSenderId: "544503941468",
  appId: "1:544503941468:web:c217ab4215c5bcbf959999",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//const messaging = firebase.messaging();
//messaging.usePublicVapidKey(
//  "BPCTeGI3QBSc1fhhMUnPnPgJCMyOIapRqu8VF-RD9caREZUrTkRIVdQU-gvuaNWzdn-D3qe8C9gf4Z07g8vCtQo"
//);
//messaging
//.requestPermission()
//.then(function() {
// console.log("We have permission to send message");
//permission accepted
// messaging
// .getToken()
// .then(currentToken => {
// if (currentToken) {
// sendTokenToServer(currentToken);
//updateUIForPushEnabled(currentToken);
//} else {
// Show permission request.
//console.log(
//"No Instance ID token available. Request permission to generate one."
//);
// Show permission UI.
//     updateUIForPushPermissionRequired();
//setTokenSentToServer(false);
// }
// })
// .catch(err => {
// console.log("An error occurred while retrieving token. ", err);
//showToken("Error retrieving Instance ID token. ", err);
//setTokenSentToServer(false);
//});
//})
//.then(function(token) {
// console.log(token);
//})
//.catch(function(err) {
//console.log("we did not get your permission to push message");
//});

//messaging.onMessage(function(payload) {
//console.log("OnMessage", payload);
//});

import { mixin } from "../js/mixin";
export default {
  data() {
    return {
      // Framework7 Parameters
      userEmail: null,
      f7params: {
        id: "com.misscomely.miss", // App bundle ID
        name: "Miss Comely", // App name
        theme: "auto", // Automatic theme detection
        // App root data
        data: function () {
          return {
            user: {
              firstName: "John",
              lastName: "Doe",
            },
            // Demo products for Catalog section
            products: [
              {
                id: "1",
                title: "Apple iPhone 8",
                description:
                  "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi tempora similique reiciendis, error nesciunt vero, blanditiis pariatur dolor, minima sed sapiente rerum, dolorem corrupti hic modi praesentium unde saepe perspiciatis.",
              },
              {
                id: "2",
                title: "Apple iPhone 8 Plus",
                description:
                  "Velit odit autem modi saepe ratione totam minus, aperiam, labore quia provident temporibus quasi est ut aliquid blanditiis beatae suscipit odio vel! Nostrum porro sunt sint eveniet maiores, dolorem itaque!",
              },
              {
                id: "3",
                title: "Apple iPhone X",
                description:
                  "Expedita sequi perferendis quod illum pariatur aliquam, alias laboriosam! Vero blanditiis placeat, mollitia necessitatibus reprehenderit. Labore dolores amet quos, accusamus earum asperiores officiis assumenda optio architecto quia neque, quae eum.",
              },
            ],
          };
        },

        // App routes
        routes: routes,

        // Input settings
        input: {
          scrollIntoViewOnFocus: this.$device.cordova && !this.$device.electron,
          scrollIntoViewCentered:
            this.$device.cordova && !this.$device.electron,
        },
        // Cordova Statusbar settings
        statusbar: {
          overlay: (this.$device.cordova && this.$device.ios) || "auto",
          iosOverlaysWebView: true,
          androidOverlaysWebView: false,
        },
      },

      // Login screen data
      username: "",
      password: "",
    };
  },
  mixins: [mixin],
  computed: {
    user() {
      return this.$store.getters.user;
    },
    user_pageSize() {
      return this.$store.getters.user_pageSize;
    },
    show_tabbar() {
      return this.$store.getters.show_tabbar;
    },
    signed_in() {
      return this.$store.getters.signed_in;
    },
    photo_url() {
      return this.$store.getters.photo_url;
    },
    display_name() {
      return this.$store.getters.display_name;
    },

    user_location() {
      return this.$store.getters.user_location;
    },
    user_club() {
      return this.$store.getters.user_club;
    },
    profile_message() {
      return this.$store.getters.profile_message;
    },
  },

  watch: {
    user(value) {
      if (value != null) {
        //console.log("am in the watch routine", value);
        this.userEmail = value[0].email;
        //console.log(this.userEmail);
        // setInterval(this.doSomething, 60000);
      }
    },
  },
  methods: {
    deleteAccount() {
      //console.log("Delete Account");
      var dialog = this.$f7.dialog
        .create({
          title: "Delete Account?",
          text: "Your Profile including your messages will be deleted. Confirm if you want to continue with the Account Deletion",
          content: "",

          buttons: [{ text: "No", close: true }, { text: "Yes" }],
          onClick: (dialog, index) => {
            if (index == 1) {
              const app = this.$f7;
              //var payload = {};
              //payload.profileMessage = response;
              var payload = {};
              payload.email = this.user[0].email;
              payload.domain = this.user[0].domain;
              this.$store.dispatch("deleteAccount", payload);
              this.$f7.dialog.close();
              app.panel.close();
            } else {
            }
          },
          on: {
            open: function () {
              //console.log("OPEN");
            },
          },
        })
        .open();
    },
    editClub() {
      var dialog = this.$f7.dialog
        .create({
          title: "Enter your new club name",
          text: "",
          content:
            '<div class="dialog-input-field item-input"><div class="item-input-wrap"><input class="dialog-input" type="text" placeholder="Enter Your New Club" maxlength="10"></div></div>',

          buttons: [{ text: "Cancel", close: true }, { text: "Ok" }],
          onClick: (dialog, index) => {
            //console.log("nosa");
            //console.log(dialog.$el.find(".dialog-input").val());
            var response = dialog.$el.find(".dialog-input").val().trim();
            if (response.length > 0) {
              var payload = {};
              payload.club = response;
              this.$store.dispatch("editClub", payload);
              this.$f7.dialog.close();
            } else {
              //console.log("index", index);
              if (index == 1) {
                this.$store.commit(
                  "setAlertMessage",
                  "Empty Message is not allowed"
                );
              }
            }
          },
          on: {
            open: function () {
              console.log("OPEN");
            },
          },
        })
        .open();
    },

    editLocation() {
      var dialog = this.$f7.dialog
        .create({
          title: "Enter New Location",
          text: "",
          content:
            '<div class="dialog-input-field item-input"><div class="item-input-wrap"><input class="dialog-input" type="text" placeholder="Enter Your New Location" maxlength="50"></div></div>',

          buttons: [{ text: "Cancel", close: true }, { text: "Ok" }],
          onClick: (dialog, index) => {
            //console.log("nosa");
            //console.log(dialog.$el.find(".dialog-input").val());
            var response = dialog.$el.find(".dialog-input").val().trim();
            if (response.length > 0) {
              var payload = {};
              payload.location = response;
              payload.email = this.user[0].email;
              payload.domain = this.user[0].domain;
              this.$store.dispatch("editLocation", payload);
              this.$f7.dialog.close();
            } else {
              //console.log("index", index);
              if (index == 1) {
                this.$store.commit(
                  "setAlertMessage",
                  "Empty Message is not allowed"
                );
              }
            }
          },
          on: {
            open: function () {
              console.log("OPEN");
            },
          },
        })
        .open();
    },

    genderSearch() {
      var dialog = this.$f7.dialog
        .create({
          title: "Enter Gender Search ( M or F)",
          text: "",
          content:
            '<div class="dialog-input-field item-input"><div class="item-input-wrap"><input class="dialog-input" type="text" placeholder="Enter New Gender Search" required maxlength="1" ></div></div>',

          buttons: [{ text: "Cancel", close: true }, { text: "Ok" }],
          onClick: (dialog, index) => {
            //console.log("nosa");
            //console.log(dialog.$el.find(".dialog-input").val());
            var response = dialog.$el.find(".dialog-input").val().trim();
            if (response.length > 0) {
              var payload = {};
              payload.genderSearch = response;
              payload.email = this.user[0].email;
              payload.domain = this.user[0].domain;
              if (response == "M" || response == "F") {
                this.$store.dispatch("editgenderSearch", payload);
                this.$f7.dialog.close();
              } else {
                this.$store.commit(
                  "setAlertMessage",
                  "Allowed inputs are 'M' or 'F'"
                );
              }
            } else {
              //console.log("index", index);
              if (index == 1) {
                this.$store.commit(
                  "setAlertMessage",
                  "Empty Message is not allowed"
                );
              }
            }
          },
          on: {
            open: function () {
              //console.log("OPEN");
            },
          },
        })
        .open();
    },

    editProfileMessage() {
      var dialog = this.$f7.dialog
        .create({
          title: "Enter New Profile Message",
          text: "",
          content:
            '<div class="dialog-input-field item-input"><div class="item-input-wrap"><input class="dialog-input" type="text" placeholder="Enter New Profile Message" maxlength="200"></div></div>',

          buttons: [{ text: "Cancel", close: true }, { text: "Ok" }],
          onClick: (dialog, index) => {
            //console.log("nosa");
            //console.log(dialog.$el.find(".dialog-input").val());
            var response = dialog.$el.find(".dialog-input").val().trim();
            if (response.length > 0) {
              var payload = {};
              payload.profileMessage = response;
              payload.email = this.user[0].email;
              payload.domain = this.user[0].domain;
              this.$store.dispatch("editProfileMessage", payload);
              this.$f7.dialog.close();
            } else {
              //console.log("index", index);
              if (index == 1) {
                this.$store.commit(
                  "setAlertMessage",
                  "Empty Message is not allowed"
                );
              }
            }
          },
          on: {
            open: function () {
              console.log("OPEN");
            },
          },
        })
        .open();
    },
    sendTokenToServer(token) {
      console.log(token);
    },
    alertLoginData() {
      this.$f7.dialog.alert(
        "Username: " + this.username + "<br>Password: " + this.password
      );
    },
    signOut() {
      const app = this.$f7;
      this.$store.dispatch("signOut");
      app.panel.close();
    },
  },
  mounted() {
    //console.log("Mounted");

    this.$f7ready((f7) => {
      // Init cordova APIs (see cordova-app.js)
      if (f7.device.cordova) {
        cordovaApp.init(f7);
      }
      // Call F7 APIs here
    });
  },
};
</script>
<style scoped>
.wrapper {
  text-align: center;
}

.image--cover {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: 20px;
  object-fit: cover;
  object-position: center;
}
</style>

